@if (label) {
	<ic-label [help]="help" [missing]="missing" [missingText]="missingText" [required]="required">
		{{ label }}
	</ic-label>
}
<div class="content">
	<div class="preview">
		@if (selected) {
			<i [class]="selected"></i>
		}
	</div>
	<div class="pv-select-input" [class.disabled]="disabled" (focusClick)="setFocus()" (keydown.space)="setFocus()">
		<p role="select" tabindex="0">
			{{ placeholder }} <i aria-hidden="true" class="selector fa fa-caret-down" data-test="expand-icons-button"> </i>
		</p>
	</div>
	@if (hasFocus) {
		<div class="pv-select-options">
			<ul>
				@for (icon of icons; track icon) {
					<li
						data-test="input-icons"
						[class.selected]="icon === selected"
						(focusClick)="selectIcon(icon)"
						(keydown.space)="selectIcon(icon)"
					>
						<i [class]="icon"></i>
					</li>
				}
			</ul>
		</div>
	}
</div>

<div [class.error]="error"><ng-content select=".errors" /></div>
